'use strict';

module.exports = require('./lib/get-css');
